module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion2_en.ee73740baf09c59332d128345ad3b2d3.png";